module.exports = __webpack_public_path__ + "static/media/food-freedom.8b65cdf0.svg";